import { Storage, Auth } from 'aws-amplify';
import { BugTrackerInterface, setBugTracker } from '../utilities/bugTracker';

// Since our Auth relies on Google env variables we need to configure

type ConfigOptions = {
  amplify: Record<string, unknown>;
  bugTracker?: BugTrackerInterface;
};

export default function configure(options: ConfigOptions) {
  const { bugTracker, amplify } = options;
  Auth.configure(amplify);
  Storage.configure(amplify);
  if (bugTracker) {
    setBugTracker(bugTracker);
  }
}
